import { render } from "./Functionalities.vue?vue&type=template&id=72c4bfd8&scoped=true"
import script from "./Functionalities.vue?vue&type=script&lang=js"
export * from "./Functionalities.vue?vue&type=script&lang=js"

import "./Functionalities.vue?vue&type=style&index=0&id=72c4bfd8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c4bfd8"]])

export default __exports__